import Blockly from "blockly";
import Schema from "../schema";

export const menu = {
  'level_add_curse': {
    name: (<div className="text"><u>A</u>dd Curse</div>),
    trigger: 'a',
  },
  'level_remove_curse': {
    name: (<div className="text"><u>R</u>emove Curse</div>),
    trigger: 'r',
  }
}

/* ****************************************************************************************************************
 * Remove Curse
 ******************************************************************************************************************/
Blockly.Blocks['level_add_curse'] = {
  init: function () {
    let shadow = this.workspace.newBlock('default_level_add_curse');
    shadow.setShadow(true);
    shadow.initSvg();
    shadow.render();

    this.appendValueInput('Input')
      .setCheck(['curse'])
      .appendField('Add curse')
      .connection
      .connect(shadow.outputConnection);

    this.setInputsInline(false);
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setColour('#606060');
    this.setTooltip('Applies the specified curse.');
  }
}

Blockly.JSON['level_add_curse'] = (block) => {
  let params = Blockly.JSON.valueToCode(block, 'Input', Blockly.JSON.ORDER_ATOMIC);

  if (params) {
    return {
      action: 'level_add_curse',
      params
    }
  } else {
    return {
      action: 'level_add_curse',
      params: {
        type: 'curse',
        entity_id: -1
      }
    }
  }
}

Blockly.Blocks['default_level_add_curse'] = {
  init: function() {
    this.appendDummyInput('Input')
      .appendField('Random Curse')
    this.setOutput(true, ['curse'])
  }
}

Blockly.JSON['default_level_add_curse'] = (block) => {
  return {
    entity_id: -1
  }
}

Schema.registerAction('level_add_curse', {
  "if": {
    "properties": {
      "action": {
        "const": "level_add_curse"
      }
    }
  },
  "then": {
    "properties": {
      "params": {
        "properties": {
          "entity_id": {
            "type": "number"
          },
          "type": {
            "enum": [
              "curse"
            ]
          },
          "from_param": {
            "type": "string"
          },
        },
        "oneOf": [
          {
            "required": [
              "entity_id"
            ],
          },
          {
            "required": [
              "from_param"
            ],
          },
        ],
        "additionalProperties": false
      }
    }
  }
});

/* ****************************************************************************************************************
 * Remove Curse
 ******************************************************************************************************************/
Blockly.Blocks['level_remove_curse'] = {
  init: function () {
    let shadow = this.workspace.newBlock('default_level_remove_curse');
    shadow.setShadow(true);
    shadow.initSvg();
    shadow.render();

    this.appendValueInput('Input')
      .setCheck(['curse'])
      .appendField('Remove curse')
      .connection
      .connect(shadow.outputConnection);
    this.setInputsInline(false);
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setColour('#606060');
    this.setTooltip('Remove the specified curse.');
  }
}

Blockly.JSON['level_remove_curse'] = (block) => {
  let params = Blockly.JSON.valueToCode(block, 'Input', Blockly.JSON.ORDER_ATOMIC);

  if (params) {
    return {
      action: 'level_remove_curse',
      params
    }
  } else {
    return {
      action: 'level_remove_curse',
      params: {
        type: 'curse',
        entity_id: -1
      }
    }
  }
}

Blockly.Blocks['default_level_remove_curse'] = {
  init: function() {
    this.appendDummyInput('Input')
      .appendField('all Curses')
    this.setOutput(true, ['curse'])
  }
}

Blockly.JSON['default_level_remove_curse'] = (block) => {
  return {
    entity_id: -1
  }
}

Schema.registerAction('level_remove_curse', {
  "if": {
    "properties": {
      "action": {
        "const": "level_remove_curse"
      }
    }
  },
  "then": {
    "properties": {
      "params": {
        "properties": {
          "entity_id": {
            "type": "number"
          },
          "type": {
            "enum": [
              "curse"
            ]
          },
          "from_param": {
            "type": "string"
          },
        },
        "oneOf": [
          {
            "required": [
              "entity_id"
            ],
          },
          {
            "required": [
              "from_param"
            ],
          },
        ],
        "additionalProperties": false
      }
    }
  }
});

